<template>
    <div id="rating" class="widget">
        <h4 class="widgettitle" style="margin-top:20px">{{ this.trans_title }}</h4>
        <div class="stars">
            <div class="form-group input-rating star-container stars-3" :title="hoverMessage(3)" @click="emitEvent(3)">
                <div style="margin-left: -15px">
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-1" disabled>
                    <label for="rating-restaurant-1" id="rating-1" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-2" disabled>
                    <label for="rating-restaurant-2" id="rating-2" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-3" disabled>
                    <label for="rating-restaurant-3" id="rating-3" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-4" disabled>
                    <label for="rating-restaurant-4" id="rating-4"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-5" disabled>
                    <label for="rating-restaurant-5" id="rating-5"></label>
                </div>
            </div>

            <div class="form-group input-rating star-container stars-4" :title="hoverMessage(4)" @click="emitEvent(4)">
                <div style="margin-left: -15px">
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-1" disabled>
                    <label for="rating-restaurant-1" id="rating-1" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-2" disabled>
                    <label for="rating-restaurant-2" id="rating-2" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-3" disabled>
                    <label for="rating-restaurant-3" id="rating-3" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-4" disabled>
                    <label for="rating-restaurant-4" id="rating-4" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-5" disabled>
                    <label for="rating-restaurant-5" id="rating-5"></label>
                </div>
            </div>

            <div class="form-group input-rating star-container stars-5" :title="hoverMessage(5)" @click="emitEvent(5)">
                <div style="margin-left: -15px">
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-1" disabled>
                    <label for="rating-restaurant-1" id="rating-1" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-2" disabled>
                    <label for="rating-restaurant-2" id="rating-2" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-3" disabled>
                    <label for="rating-restaurant-3" id="rating-3" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-4" disabled>
                    <label for="rating-restaurant-4" id="rating-4" class="marked"></label>
                    <input type="radio" name="rating-restaurant" id="rating-restaurant-5" disabled>
                    <label for="rating-restaurant-5" id="rating-5" class="marked"></label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import search from '../search';

export default {
    mixins: [
        search
    ],
    props: {
        trans_title: {
            type: String,
            default: 'Ratings'
        },
        trans_hover: {
            type: String,
            default: 'Show restaurants with :number stars'
        }
    },
    data() {
        return {
            stars: [],
            rating: [],
        }
    },
    methods: {
        emitEvent(stars) {
            if (typeof stars !== 'undefined') {
                if (this.inArray(stars, this.stars)) {
                    this.stars.splice(this.stars.indexOf(stars), 1);
                } else {
                    this.stars.push(stars);
                }

                $('.stars-' + stars).toggleClass('active');
            }

            this.eventHub.$emit('rating-ticked', this.stars);
        },
        hoverMessage(stars) {
            return this.trans_hover.replace(':number', stars);
        },
        inArray(needle, haystack) {
            let length = haystack.length;

            for (let i = 0; i < length; i++) {
                if (haystack[i] === needle) return true;
            }
            return false;
        },
        setSearchedRating() {
            let ratings = this.getUserSearchSessionByType('rating');

            if (ratings.length > 0) {
                this.rating = ratings.map(rating => rating.value);

                this.stars = this.rating.map(function (value) {
                    $('.stars-' + value).addClass('active');

                    return parseInt(value);
                });

                let self = this;

                setTimeout(function () {
                    self.emitEvent();
                }, 200);
            }
        }
    },
    created() {
        let self = this;

        this.eventHub.$on('reset_rating', (rating) => {
            $('.stars-' + rating).removeClass('active');

            self.rating = self.rating.filter(r => parseInt(r) !== parseInt(rating));
            self.stars = self.stars.filter(s => parseInt(s) !== parseInt(rating));

            self.emitEvent();
        });
    },
    mounted() {
        this.setSearchedRating();
    },
}
</script>

<style scoped>
.star-container {
    background: white;
    padding: 12px 0 12px 0;
    text-align: center;
    margin-bottom: 13px;
    cursor: pointer;
}

.star-container:hover {
    margin: -2px 0 11px 0;
    border: 2px #7F9741 solid;
}

.star-container:active {
    background: #7F9741;
}

.active {
    background: #7F9741;
    margin: -2px 0 11px 0;
    border: 2px #7F9741 solid;
}

label {
    width: 43.6px !important;
    margin-bottom: 0px;

}

label::before {
    font-size: 35px !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/RestaurantSearchRating.vue